"use client";
import {NeoButton, NeoTextBox} from "@/components/forms";
export const InputParammeter = function () {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <p className="text-sm ">Student data</p>
        <div
          className="flex items-center justify-between rounded-lg border bg-gray-50 p-1"
          key={1}
        >
          <div className="flex items-center space-x-3">
            <div className="text-blue-600">
              {/* Document Icon */}
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.8363 10.9916C18.9031 11.0584 18.9562 11.1377 18.9923 11.2249C19.0285 11.3122 19.0471 11.4057 19.0471 11.5002C19.0471 11.5946 19.0285 11.6881 18.9923 11.7754C18.9562 11.8626 18.9031 11.9419 18.8363 12.0087L11.4646 19.3759C10.5209 20.3195 9.24103 20.8495 7.90651 20.8494C6.57198 20.8493 5.29215 20.3191 4.34856 19.3754C3.40497 18.4317 2.87492 17.1518 2.875 15.8173C2.87508 14.4828 3.4053 13.2029 4.34901 12.2593L13.2669 3.21027C13.9406 2.53582 14.8547 2.15663 15.808 2.15613C16.7613 2.15562 17.6758 2.53384 18.3503 3.20758C19.0247 3.88132 19.4039 4.79539 19.4044 5.7487C19.4049 6.70201 19.0267 7.61649 18.353 8.29094L9.43327 17.34C9.02819 17.7451 8.47879 17.9726 7.90593 17.9726C7.33306 17.9726 6.78366 17.7451 6.37858 17.34C5.97351 16.9349 5.74594 16.3855 5.74594 15.8127C5.74594 15.2398 5.97351 14.6904 6.37858 14.2853L13.8626 6.68273C13.9281 6.6128 14.007 6.55668 14.0946 6.51769C14.1822 6.4787 14.2766 6.45762 14.3725 6.45569C14.4683 6.45376 14.5636 6.47102 14.6526 6.50646C14.7417 6.54189 14.8228 6.59479 14.8911 6.66203C14.9594 6.72927 15.0136 6.8095 15.0505 6.898C15.0873 6.98649 15.1061 7.08146 15.1057 7.17732C15.1053 7.27318 15.0857 7.36799 15.0481 7.45617C15.0105 7.54435 14.9557 7.62412 14.8868 7.69078L7.4019 15.3014C7.33489 15.3679 7.28162 15.447 7.24515 15.534C7.20868 15.6211 7.18972 15.7145 7.18934 15.8089C7.18896 15.9033 7.20719 15.9968 7.24296 16.0842C7.27874 16.1716 7.33138 16.251 7.39786 16.318C7.46434 16.385 7.54338 16.4383 7.63045 16.4748C7.71751 16.5113 7.81091 16.5302 7.90531 16.5306C7.99971 16.531 8.09326 16.5127 8.18062 16.477C8.26797 16.4412 8.34743 16.3886 8.41444 16.3221L17.3332 7.2775C17.7383 6.87326 17.9662 6.32466 17.9668 5.75238C17.9674 5.18011 17.7406 4.63103 17.3364 4.22596C16.9321 3.82088 16.3835 3.59298 15.8113 3.59239C15.239 3.5918 14.6899 3.81857 14.2848 4.22281L5.36874 13.2683C5.03472 13.6018 4.76967 13.9978 4.58869 14.4337C4.40772 14.8696 4.31439 15.3369 4.31401 15.8089C4.31364 16.2809 4.40623 16.7483 4.58651 17.1845C4.76678 17.6208 5.03121 18.0172 5.3647 18.3512C5.69818 18.6852 6.09418 18.9503 6.5301 19.1312C6.96602 19.3122 7.43332 19.4055 7.90531 19.4059C8.37731 19.4063 8.84475 19.3137 9.28096 19.1334C9.71716 18.9531 10.1136 18.6887 10.4476 18.3552L17.8202 10.988C17.9554 10.8538 18.1385 10.7788 18.329 10.7795C18.5195 10.7802 18.702 10.8565 18.8363 10.9916Z"
                  fill="#FFC727"
                />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">
                sample filename
              </p>
              <p className="text-xs text-gray-600">20kb</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            {/* DELETE */}
            <button
              className="text-red-500 hover:text-red-700"
              //removeDocument(field.id)

              title="Delete Document"
            >
              {/* Delete Icon */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.3"
                  d="M9.80073 3.67175C6.19825 3.67175 3.26562 6.60438 3.26562 10.2069C3.26562 13.8093 6.19825 16.742 9.80073 16.742C13.4032 16.742 16.3358 13.8093 16.3358 10.2069C16.3358 6.60438 13.4032 3.67175 9.80073 3.67175ZM13.0683 12.3226L11.9165 13.4744L9.80073 11.3587L7.68499 13.4744L6.53318 12.3226L8.64892 10.2069L6.53318 8.09112L7.68499 6.9393L9.80073 9.05504L11.9165 6.9393L13.0683 8.09112L10.9525 10.2069L13.0683 12.3226Z"
                  fill="#FF5555"
                />
                <path
                  d="M11.9174 6.93929L9.80169 9.05503L7.68595 6.93929L6.53414 8.0911L8.64988 10.2068L6.53414 12.3226L7.68595 13.4744L9.80169 11.3587L11.9174 13.4744L13.0692 12.3226L10.9535 10.2068L13.0692 8.0911L11.9174 6.93929ZM9.80169 2.03796C5.2843 2.03796 1.63281 5.68945 1.63281 10.2068C1.63281 14.7242 5.2843 18.3757 9.80169 18.3757C14.3191 18.3757 17.9706 14.7242 17.9706 10.2068C17.9706 5.68945 14.3191 2.03796 9.80169 2.03796ZM9.80169 16.7419C6.19922 16.7419 3.26659 13.8093 3.26659 10.2068C3.26659 6.60437 6.19922 3.67174 9.80169 3.67174C13.4042 3.67174 16.3368 6.60437 16.3368 10.2068C16.3368 13.8093 13.4042 16.7419 9.80169 16.7419Z"
                  fill="#FF5555"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm ">Vehicle data</p>
        <div
          className="flex items-center justify-between rounded-lg border bg-gray-50 p-1"
          key={1}
        >
          <div className="flex items-center space-x-3">
            <div className="text-blue-600">
              {/* Document Icon */}
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.8363 10.9916C18.9031 11.0584 18.9562 11.1377 18.9923 11.2249C19.0285 11.3122 19.0471 11.4057 19.0471 11.5002C19.0471 11.5946 19.0285 11.6881 18.9923 11.7754C18.9562 11.8626 18.9031 11.9419 18.8363 12.0087L11.4646 19.3759C10.5209 20.3195 9.24103 20.8495 7.90651 20.8494C6.57198 20.8493 5.29215 20.3191 4.34856 19.3754C3.40497 18.4317 2.87492 17.1518 2.875 15.8173C2.87508 14.4828 3.4053 13.2029 4.34901 12.2593L13.2669 3.21027C13.9406 2.53582 14.8547 2.15663 15.808 2.15613C16.7613 2.15562 17.6758 2.53384 18.3503 3.20758C19.0247 3.88132 19.4039 4.79539 19.4044 5.7487C19.4049 6.70201 19.0267 7.61649 18.353 8.29094L9.43327 17.34C9.02819 17.7451 8.47879 17.9726 7.90593 17.9726C7.33306 17.9726 6.78366 17.7451 6.37858 17.34C5.97351 16.9349 5.74594 16.3855 5.74594 15.8127C5.74594 15.2398 5.97351 14.6904 6.37858 14.2853L13.8626 6.68273C13.9281 6.6128 14.007 6.55668 14.0946 6.51769C14.1822 6.4787 14.2766 6.45762 14.3725 6.45569C14.4683 6.45376 14.5636 6.47102 14.6526 6.50646C14.7417 6.54189 14.8228 6.59479 14.8911 6.66203C14.9594 6.72927 15.0136 6.8095 15.0505 6.898C15.0873 6.98649 15.1061 7.08146 15.1057 7.17732C15.1053 7.27318 15.0857 7.36799 15.0481 7.45617C15.0105 7.54435 14.9557 7.62412 14.8868 7.69078L7.4019 15.3014C7.33489 15.3679 7.28162 15.447 7.24515 15.534C7.20868 15.6211 7.18972 15.7145 7.18934 15.8089C7.18896 15.9033 7.20719 15.9968 7.24296 16.0842C7.27874 16.1716 7.33138 16.251 7.39786 16.318C7.46434 16.385 7.54338 16.4383 7.63045 16.4748C7.71751 16.5113 7.81091 16.5302 7.90531 16.5306C7.99971 16.531 8.09326 16.5127 8.18062 16.477C8.26797 16.4412 8.34743 16.3886 8.41444 16.3221L17.3332 7.2775C17.7383 6.87326 17.9662 6.32466 17.9668 5.75238C17.9674 5.18011 17.7406 4.63103 17.3364 4.22596C16.9321 3.82088 16.3835 3.59298 15.8113 3.59239C15.239 3.5918 14.6899 3.81857 14.2848 4.22281L5.36874 13.2683C5.03472 13.6018 4.76967 13.9978 4.58869 14.4337C4.40772 14.8696 4.31439 15.3369 4.31401 15.8089C4.31364 16.2809 4.40623 16.7483 4.58651 17.1845C4.76678 17.6208 5.03121 18.0172 5.3647 18.3512C5.69818 18.6852 6.09418 18.9503 6.5301 19.1312C6.96602 19.3122 7.43332 19.4055 7.90531 19.4059C8.37731 19.4063 8.84475 19.3137 9.28096 19.1334C9.71716 18.9531 10.1136 18.6887 10.4476 18.3552L17.8202 10.988C17.9554 10.8538 18.1385 10.7788 18.329 10.7795C18.5195 10.7802 18.702 10.8565 18.8363 10.9916Z"
                  fill="#FFC727"
                />
              </svg>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">
                sample filename
              </p>
              <p className="text-xs text-gray-600">20kb</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            {/* DELETE */}
            <button
              className="text-red-500 hover:text-red-700"
              //removeDocument(field.id)

              title="Delete Document"
            >
              {/* Delete Icon */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.3"
                  d="M9.80073 3.67175C6.19825 3.67175 3.26562 6.60438 3.26562 10.2069C3.26562 13.8093 6.19825 16.742 9.80073 16.742C13.4032 16.742 16.3358 13.8093 16.3358 10.2069C16.3358 6.60438 13.4032 3.67175 9.80073 3.67175ZM13.0683 12.3226L11.9165 13.4744L9.80073 11.3587L7.68499 13.4744L6.53318 12.3226L8.64892 10.2069L6.53318 8.09112L7.68499 6.9393L9.80073 9.05504L11.9165 6.9393L13.0683 8.09112L10.9525 10.2069L13.0683 12.3226Z"
                  fill="#FF5555"
                />
                <path
                  d="M11.9174 6.93929L9.80169 9.05503L7.68595 6.93929L6.53414 8.0911L8.64988 10.2068L6.53414 12.3226L7.68595 13.4744L9.80169 11.3587L11.9174 13.4744L13.0692 12.3226L10.9535 10.2068L13.0692 8.0911L11.9174 6.93929ZM9.80169 2.03796C5.2843 2.03796 1.63281 5.68945 1.63281 10.2068C1.63281 14.7242 5.2843 18.3757 9.80169 18.3757C14.3191 18.3757 17.9706 14.7242 17.9706 10.2068C17.9706 5.68945 14.3191 2.03796 9.80169 2.03796ZM9.80169 16.7419C6.19922 16.7419 3.26659 13.8093 3.26659 10.2068C3.26659 6.60437 6.19922 3.67174 9.80169 3.67174C13.4042 3.67174 16.3368 6.60437 16.3368 10.2068C16.3368 13.8093 13.4042 16.7419 9.80169 16.7419Z"
                  fill="#FF5555"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="flex justify-between gap-2">
        <NeoTextBox
          // {...field}
          label="Max Distance(KM)"
          placeholder="Max KM"
          id="maxKm"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
        <NeoTextBox
          // {...field}
          label="Max Time"
          placeholder="Max Time"
          id="maxTime"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
      </div>
      <div className="flex justify-between gap-2">
        <NeoTextBox
          // {...field}
          label="Wait Time(Min)"
          placeholder="Wait Time"
          id="waitTime"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
        <NeoTextBox
          // {...field}
          label="Capacity %"
          placeholder="Capacity"
          id="capacity"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
      </div>
      <div className="flex justify-between gap-2">
        <NeoTextBox
          // {...field}
          label="Start Time"
          placeholder="Time"
          id="startTime"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
        <NeoTextBox
          // {...field}
          label="End Time"
          placeholder="time"
          id="endTime"
          size="sm"
          // color={errors.info1 ? "danger" : "default"}
          // isInvalid={errors.info1 ? true : false}
          // errorMessage={
          //   errors.info1 && `${errors.info1.message}`
          // }
          autoComplete="off"
          // {...register("info1")}
          // onChange={e => {
          //   field.onChange(e);
          //   msgreplaceword(e);
          // }}
        />
      </div>
      <NeoButton
        className="mx-5 mt-2"
        type="submit"
        size="sm"
        // disabled={isSubmitting}
        // isLoading={loading}
        // spinner={
        //   <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
        // }
        color="black"
        startContent={
          <>
            <svg
              width="11"
              height="15"
              viewBox="0 0 11 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.88379 9.08757C4.78648 9.3691 4.37425 9.3691 4.27694 9.08757L3.70636 7.43506C3.58076 7.0718 3.36916 6.74174 3.08832 6.47105C2.80748 6.20036 2.46512 5.99647 2.08838 5.87555L0.375742 5.32528C0.0838154 5.23144 0.0838155 4.83388 0.375742 4.74004L2.08926 4.18977C2.46594 4.06865 2.80818 3.86458 3.08887 3.59374C3.36956 3.3229 3.58097 2.99273 3.70636 2.6294L4.27694 0.97775C4.29792 0.916102 4.33855 0.862417 4.39304 0.824357C4.44753 0.786297 4.51309 0.765805 4.58037 0.765805C4.64764 0.765805 4.71321 0.786297 4.76769 0.824357C4.82218 0.862417 4.86281 0.916102 4.88379 0.97775L5.45437 2.63025C5.57988 2.99342 5.79135 3.32342 6.07203 3.59411C6.35271 3.8648 6.69489 4.06873 7.07147 4.18977L8.78499 4.74004C8.84891 4.76027 8.90458 4.79945 8.94404 4.852C8.98351 4.90455 9.00476 4.96777 9.00476 5.03266C9.00476 5.09754 8.98351 5.16077 8.94404 5.21332C8.90458 5.26586 8.84891 5.30505 8.78499 5.32528L7.07147 5.87555C6.69489 5.99658 6.35271 6.20052 6.07203 6.47121C5.79134 6.74189 5.57988 7.07189 5.45437 7.43506L4.88379 9.08757ZM8.3011 13.4377C8.28841 13.4746 8.26398 13.5068 8.23126 13.5295C8.19855 13.5523 8.15922 13.5646 8.11887 13.5646C8.07851 13.5646 8.03918 13.5523 8.00647 13.5295C7.97375 13.5068 7.94932 13.4746 7.93663 13.4377L7.59428 12.4463C7.44124 12.0044 7.08209 11.658 6.62385 11.5104L5.59591 11.1803C5.55761 11.1681 5.52427 11.1445 5.50064 11.1129C5.47701 11.0814 5.46429 11.0435 5.46429 11.0045C5.46429 10.9656 5.47701 10.9277 5.50064 10.8961C5.52427 10.8646 5.55761 10.841 5.59591 10.8288L6.62385 10.4986C6.84985 10.426 7.05521 10.3036 7.22365 10.1412C7.39209 9.97876 7.51899 9.78071 7.59428 9.56276L7.93663 8.57143C7.94932 8.53448 7.97375 8.50233 8.00647 8.47954C8.03918 8.45676 8.07851 8.44449 8.11887 8.44449C8.15922 8.44449 8.19855 8.45676 8.23126 8.47954C8.26398 8.50233 8.28841 8.53448 8.3011 8.57143L8.64345 9.56276C8.71875 9.78071 8.84564 9.97876 9.01408 10.1412C9.18253 10.3036 9.38788 10.426 9.61388 10.4986L10.6418 10.8288C10.6801 10.841 10.7135 10.8646 10.7371 10.8961C10.7607 10.9277 10.7734 10.9656 10.7734 11.0045C10.7734 11.0435 10.7607 11.0814 10.7371 11.1129C10.7135 11.1445 10.6801 11.1681 10.6418 11.1803L9.61388 11.5104C9.38788 11.5831 9.18253 11.7054 9.01408 11.8679C8.84564 12.0303 8.71874 12.2284 8.64345 12.4463L8.3011 13.4377ZM2.04768 14.3326C2.03895 14.3569 2.02259 14.3779 2.00087 14.3929C1.97915 14.4078 1.95315 14.4158 1.92649 14.4158C1.89983 14.4158 1.87383 14.4078 1.85211 14.3929C1.83039 14.3779 1.81403 14.3569 1.8053 14.3326L1.57706 13.6723C1.47533 13.3771 1.2356 13.1459 0.929518 13.0478L0.244818 12.8277C0.219629 12.8193 0.197786 12.8035 0.182328 12.7825C0.16687 12.7616 0.158565 12.7365 0.158565 12.7108C0.158565 12.6851 0.16687 12.66 0.182328 12.6391C0.197786 12.6181 0.219629 12.6023 0.244818 12.5939L0.929518 12.3738C1.08036 12.3254 1.21742 12.2438 1.32982 12.1354C1.44223 12.027 1.52688 11.8948 1.57706 11.7493L1.8053 11.089C1.81403 11.0647 1.83039 11.0436 1.85211 11.0287C1.87383 11.0138 1.89983 11.0058 1.92649 11.0058C1.95315 11.0058 1.97915 11.0138 2.00087 11.0287C2.02259 11.0436 2.03895 11.0647 2.04768 11.089L2.27592 11.7493C2.3261 11.8948 2.41075 12.027 2.52315 12.1354C2.63556 12.2438 2.77262 12.3254 2.92346 12.3738L3.60728 12.5939C3.63247 12.6023 3.65431 12.6181 3.66977 12.6391C3.68522 12.66 3.69353 12.6851 3.69353 12.7108C3.69353 12.7365 3.68522 12.7616 3.66977 12.7825C3.65431 12.8035 3.63247 12.8193 3.60728 12.8277L2.92258 13.0478C2.6165 13.1459 2.37676 13.3771 2.27503 13.6723L2.04768 14.3326Z"
                fill="white"
              />
            </svg>
          </>
        }
      >
        Generate Optimized Route
      </NeoButton>
    </div>
  );
};
